import { render, staticRenderFns } from "./BomList.vue?vue&type=template&id=6081ed90&"
import script from "./BomList.vue?vue&type=script&lang=js&"
export * from "./BomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports